//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as moment from "moment";

// custom pages
import Table from "components/Table/Table";
import useDebounce from "helpers/useDebounce";
import { Styles } from "./styles";
import Loader from "components/Loader/Loader";
import TransactionsApi from "apis/transactions/transactions";
import { csvHeadings } from "./export";
import searchIcon from "assets/img/Search_Icon.png";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
// material-ui icons
import FilterListIcon from "@material-ui/icons/FilterList";
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

//ant-ui
import { Popover } from "antd";
import { CSVLink } from "react-csv";
import { useTranslation } from 'react-i18next';


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Transactions(props) {
  const { state, dispatch } = useContext(context);
  const { get, search, filter, transactionExport } = TransactionsApi();
  const classes = Styles();
  const history = useHistory();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [exportData, setExportData] = useState([]);
  const [response, setResponse] = useState(false);
  const { t, i18n } = useTranslation();

  const [states, setstates] = useState({
    filter: false,
    transaction_type: "",
    transaction_status: "",
    startDate: null,
    endDate: null,
    popover: false,
    loyalty_id: "",
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "POINTS ADJUSTMENTS"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      states.filter
        ? handleFilter()
        : searchValue.length > 0
        ? handleSearch()
        : handleGet();
    }
  }, [state.userInfo, offset]);

  // handling search api
  useEffect(() => {
    const offsetParams = location?.state?.offsetParams;
    const searchValueParams = location?.state?.searchValueParams;

    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else if (offsetParams && searchValueParams) {
      setOffset(offsetParams);
      setSearchValue(searchValueParams);
      location.state = undefined;
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // authorized members api func
  const handleGet = async () => {
    // try {
    //   let values;
    //   values = {
    //     offset: (offset - 1) * 10,
    //     limit: 10,
    //   };
    //   dispatch({ type: "SET_LOADING", payload: true });
    //   let res = await get(values);
    //   if (res) {
    //     setData(res.data);
    //     setCount(res.count);
    //     dispatch({ type: "SET_LOADING", payload: false });
    //   }
    // } catch (e) {
    //   console.log({ e });
    // }
  };

  // // search api func
  const handleSearch = async () => {
    setStates({
      filter: false,
      transaction_type: "",
      transaction_status: "",
    });
    try {
      let values;
      if (!searchValue.replace(/\s/g, "").length) {
        return;
      }
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setResponse(true);
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      dispatch({ type: "SET_LOADING", payload: false });
      setData([]);
    } catch (e) {
      console.log({ e });
    }
  };

  // // filter api func
  const handleFilter = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (states.transaction_type && states.transaction_type.length > 0) {
        values = {
          ...values,
          type: states.transaction_type,
        };
      }
      if (states.startDate != null && states.endDate != null) {
        values = {
          ...values,
          startDate: states.startDate,
          endDate: states.endDate,
        };
      }
      if (states.transaction_status && states.transaction_status.length > 0) {
        values = {
          ...values,
          status: states.transaction_status,
        };
      }
      if (states.loyalty_id && states.loyalty_id.length > 0) {
        values = {
          ...values,
          loyaltyId: states.loyalty_id,
        };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filter(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse(true);
        setStates({ filter: true });
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleExport = async () => {
    try {
      let values = {};
      if (states.transaction_type && states.transaction_type.length > 0) {
        values = {
          ...values,
          type: states.transaction_type,
        };
      }
      if (states.startDate != null && states.endDate != null) {
        values = {
          ...values,
          startDate: states.startDate,
          endDate: states.endDate,
        };
      }
      if (states.transaction_status && states.transaction_status.length > 0) {
        values = {
          ...values,
          status: states.transaction_status,
        };
      }
      if (states.loyalty_id && states.loyalty_id.length > 0) {
        values = {
          ...values,
          loyaltyId: states.loyalty_id,
        };
      }
      if (!states.filter && searchValue.length > 0) {
        values = {
          ...values,
          search: searchValue,
        };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await transactionExport(values);
      if (res) {
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return;
        }
        return true;
      }
      return false;
    } catch (e) {
      console.log({ e });
    }
  };

  const tableHeadings = [
    "Transaction Id",
    "Order date",
    "Shipto",
    "Billto",
    "Loyalty Id",
    "Type",
    "Transaction Type",
    "Transaction status",
    "View more",
  ];
  return (
    <React.Fragment>
      <Grid
        container
        className={classes.root}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        <Grid item lg={12}>
          <div className={classes.headingText2}>
            Please type the customer ship to account number or Loyalty ID to
            view their loyalty information
          </div>
        </Grid>
        <Grid xs={12} sm={12} lg={6} className={classes.topGrid}>
          <CssTextField
            id="enterPassword"
            placeholder="Search for Shipto or Loyalty Id"
            type={"text"}
            variant="outlined"
            autoComplete="off"
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setOffset(1);
            }}
            onClick={() => {
              setOffset(offset);
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!states.filter) {
                setStates({ is_active: "", filterRole: "" });
              }
            }}
          >
            Filter
            {states.filter && (
              <Badge
                badgeContent={count == 0 ? "" : count}
                classes={{ badge: classes.badge }}
                max={999}
              ></Badge>
            )}
          </Button>
        </Grid>

        <CSVLink
          id="csv"
          data={exportData}
          headers={csvHeadings.map((i) => i)}
          filename={
            `transaction` +
            " " +
            moment(new Date()).format("MM-DD-YYYY,h:mm A") +
            ".csv"
          }
        />

        <Grid item className={classes.tripleDot}>
          <span className="vert-icon-wrapper">
            <Popover
              placement={"bottom"}
              color="#4472c4"
              content={
                <React.Fragment>
                  <div className={classes.exportParentDiv}>
                    <div
                      className={classes.exportDiv}
                      onClick={async () => {
                        setStates({ popover: false });
                        let res = await handleExport();
                        if (res) {
                          document.getElementById("csv").click();
                        }
                      }}
                    >
                      Export
                    </div>
                  </div>
                </React.Fragment>
              }
              trigger="click"
              visible={states.popover}
            >
              <MoreVertIcon
                onClick={() => {
                  setStates({ popover: !states.popover });
                }}
                className={classes.popover}
                style={{ margin: 0 }}
              />
            </Popover>
          </span>
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={0}
                  className={classes.filterCardGridContainer}
                >
                  <Grid
                    item
                    xs={3}
                    className={classes.filterCardGrid}
                    style={{ padding: "35px 10px 10px 15px" }}
                  >
                    <TextField
                      id={"type"}
                      label={"Transaction Type"}
                      select
                      fullWidth
                      type={"text"}
                      value={states.transaction_type}
                      onChange={(e) => {
                        setStates({ transaction_type: e.target.value });
                      }}
                    >
                      <MenuItem value={"Sales"}>Sales</MenuItem>
                      <MenuItem value={"ACH"}>ACH</MenuItem>
                      <MenuItem value={"Rebate"}>Rebate</MenuItem>
                      <MenuItem value={"Premium"}>Premium</MenuItem>
                      <MenuItem value={"Legacy Transfer"}>
                        Legacy Transfer
                      </MenuItem>
                    </TextField>
                  </Grid>

                  <Grid
                    item
                    xs={3}
                    className={classes.filterCardGrid}
                    style={{ padding: "5px 10px 10px 10px", borderRight: 0 }}
                  >
                    <b style={{ padding: 0, margin: 0 }}> Order Date Range</b>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        label="Start Date"
                        id="date-picker-inline"
                        className={classes.dateInput}
                        value={states.startDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          if (moment(date).isAfter(states.endDate)) {
                            toast.error(
                              "Start date should be greater than End date.",
                              {
                                toastId: "start-date-end-date",
                              }
                            );
                            return;
                          }
                          setStates({ startDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid
                    item
                    xs={3}
                    className={classes.filterCardGrid}
                    style={{ padding: "28px 10px 10px 10px" }}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        label="End Date"
                        id="date-picker-inline2"
                        className={classes.dateInput}
                        value={states.endDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          if (moment(states.startDate).isAfter(date)) {
                            toast.error(
                              "Start date should be greater than End date.",
                              {
                                toastId: "start-date-end-date",
                              }
                            );
                            return;
                          }
                          setStates({ endDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    className={classes.filterCardGrid}
                    style={{ padding: "35px 10px 10px 10px" }}
                  >
                    <TextField
                      id={"transaction_status"}
                      label={"Transaction status"}
                      select
                      fullWidth
                      type={"text"}
                      value={states.transaction_status}
                      onChange={(e) => {
                        setStates({ transaction_status: e.target.value });
                      }}
                    >
                      <MenuItem value={"Processed"}>Processed</MenuItem>
                      <MenuItem value={"Inprogress"}>Inprogress</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid xs={6} style={{ padding: "15px 10px 10px 10px" }}>
                    <CssTextField
                      id="enterPassword"
                      placeholder="Enter the Loyalty Id"
                      type={"text"}
                      variant="outlined"
                      autoComplete="off"
                      className={classes.searchInput}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {states.loyalty_id.length > 0 ? (
                              <CloseOutlinedIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setStates({ loyalty_id: "" });
                                }}
                              />
                            ) : (
                              <img
                                src={searchIcon}
                                alt=""
                                width="20px"
                                className={classes.searchInputIcon}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      value={states.loyalty_id}
                      onChange={(e) => {
                        setStates({ loyalty_id: e.target.value });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    className={`${classes.filterCardBtnGrid}`}
                    style={{ padding: 10, float: "right" }}
                  >
                    <Button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: 15,
                        height: 35,
                        marginTop: 0,
                      }}
                      onClick={() => {
                        if (
                          !states.transaction_type &&
                          !states.transaction_status &&
                          !states.loyalty_id &&
                          !states.startDate &&
                          !states.endDate
                        ) {
                          toast.error("Select atleast one filter value", {
                            toastId: "transactions-filter",
                          });
                          return;
                        }
                        setSearchValue("");
                        handleFilter();
                        setOffset(1);
                      }}
                    >
                      Apply
                    </Button>
                    {states.filter && (
                      <Button
                        className={classes.filterCardResetBtn}
                        onClick={() => {
                          setStates({
                            // filter: false,
                            transaction_type: "",
                            transaction_status: "",
                            startDate: null,
                            endDate: null,
                            // popover: false,
                            loyalty_id: "",
                          });
                          setOffset(1);
                          setFilterCard(false);
                          handleGet();
                          setResponse(false);
                          setCount(null);
                        }}
                      >
                        Reset
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={"15%"}>
        <Grid className={classes.tableGrid}>
          <Grid xs={12} sm={12} lg={12}>
            {response && (
              <Table
                headings={tableHeadings.map((i) => (
                  <div style={{ width: "70px" }}>{i}</div>
                ))}
                data={
                  data &&
                  data.length > 0 &&
                  data.map((d, i) => [
                    d?.transaction_id,
                    d?.order_date,
                    d?.customer_account_number,
                    d?.customer_billto_account_number,
                    d?.loyalty_id,
                    d?.type,
                    d?.transaction_type || "-",
                    d?.transaction_status,
                    [
                      <RemoveRedEyeIcon
                        className={classes.RemoveRedEyeIcon}
                        onClick={() => {
                          history.push("/dashboard/view-transaction", {
                            transactionId: d?.transaction_id,
                            offset: offset,
                            searchValue: searchValue,
                          });
                        }}
                      />,
                    ],
                  ])
                }
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            )}
          </Grid>
        </Grid>
      </Loader>
    </React.Fragment>
  );
}
